/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookClosedHelpIcon16Light } from './BookClosedHelpIcon16Light';
import { BookClosedHelpIcon16Regular } from './BookClosedHelpIcon16Regular';
import { BookClosedHelpIcon16Solid } from './BookClosedHelpIcon16Solid';
import { BookClosedHelpIcon20Light } from './BookClosedHelpIcon20Light';
import { BookClosedHelpIcon20Regular } from './BookClosedHelpIcon20Regular';
import { BookClosedHelpIcon20Solid } from './BookClosedHelpIcon20Solid';
import { BookClosedHelpIcon24Regular } from './BookClosedHelpIcon24Regular';
import { BookClosedHelpIcon24Solid } from './BookClosedHelpIcon24Solid';
import { BookClosedHelpIcon32Regular } from './BookClosedHelpIcon32Regular';
import { BookClosedHelpIcon64Regular } from './BookClosedHelpIcon64Regular';
var sizes = {
    16: {
        light: BookClosedHelpIcon16Light,
        regular: BookClosedHelpIcon16Regular,
        solid: BookClosedHelpIcon16Solid,
    },
    20: {
        light: BookClosedHelpIcon20Light,
        regular: BookClosedHelpIcon20Regular,
        solid: BookClosedHelpIcon20Solid,
    },
    24: {
        regular: BookClosedHelpIcon24Regular,
        solid: BookClosedHelpIcon24Solid,
    },
    32: {
        regular: BookClosedHelpIcon32Regular,
    },
    64: {
        regular: BookClosedHelpIcon64Regular,
    },
};
export var BookClosedHelpIcon = forwardRef('BookClosedHelpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
